import { YANDEX_METRIKA_ID } from "./constants";

export function reachGoal(goal: string, params?: Record<string, any>) {
  if (!window.ym) return;

  window.ym(YANDEX_METRIKA_ID, "reachGoal", goal, params);
}
